import type { RecordingToggleEventPublisher } from 'call-recording/recording-toggle.usecase';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';

export class RecordingTogglePublisher implements RecordingToggleEventPublisher {
  async publish(onRecordStart: boolean): Promise<void> {
    const busIframe = await BusIframe.getIframe();

    const busEvent: BusEvent = {
      type: 'DIALER.RECORD',
      payload: {
        shouldRecord: onRecordStart,
      },
    };

    return BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: busIframe,
      event: busEvent,
    });
  }
}
